export default "__VITE_ASSET__0746526f__"